export default __webpack_public_path__ + "fonts/icomoon.0b91f4da38b453c894ce2160c6a3238e.ttf";